import axios from 'axios';

import { checkRecaptcha, RecaptchaAction } from './check-recaptcha';

interface PostContactFormData {
  fullName: string | null;
  email: string;
  message: string;
  userId?: string;
}

export const postContactForm = async (data: PostContactFormData) => {
  const { fullName, email, message, userId } = data;

  const sendData: {
    email: string;
    message: string;
    userId?: string;
    fullName?: string;
  } = {
    email,
    message,
    userId
  };

  if (fullName !== '' && fullName !== null) {
    sendData.fullName = fullName;
  }

  const captchaToken = await checkRecaptcha(RecaptchaAction.CONTACT_US_FORM);

  console.log('sendData', sendData);
  return await axios.post(
    `${process.env.REACT_APP_API_URL}/api/v1/support/contact-us?captcha_action=CONTACT_US_FORM&captcha_token=${captchaToken}`,
    sendData
  );
};
